export default "__VITE_ASSET__DBlOj$u9__"